import { useEffect } from 'react';

/**
 * Tuck the floating assistant/support button away while `active` — for UI
 * docked to the bottom-right that it would otherwise cover (e.g. the forecast
 * workspace's account panel and its note composer). Ref-counted on <html>, so
 * several callers can overlap. An open assistant panel is never hidden.
 */
let holds = 0;

export function useHideAssistantLauncher(active) {
  useEffect(() => {
    if (!active) return undefined;
    holds += 1;
    document.documentElement.setAttribute('data-al-hidden', '');
    return () => {
      holds -= 1;
      if (holds <= 0) {
        holds = 0;
        document.documentElement.removeAttribute('data-al-hidden');
      }
    };
  }, [active]);
}
